import { render, staticRenderFns } from "./InsolvencyFactor.vue?vue&type=template&id=0a02daa7"
import script from "./InsolvencyFactor.vue?vue&type=script&lang=js"
export * from "./InsolvencyFactor.vue?vue&type=script&lang=js"
import style0 from "./InsolvencyFactor.vue?vue&type=style&index=0&id=0a02daa7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports